<template>
  <div class="container">
    <div class="app-order-wrapper">
      <slot name="txtBefore"></slot>
      <!--    Warenkorb-->
      <div class="order-shopping-card overview-process" v-if="!showSuccess">
        <div class="accordion-header">
          <slot name="txtAccordionHeaderShoppingCard"></slot>
        </div>
        <b-collapse v-model="showAlways">
          <OrderShoppingCard
            v-if="!showEmptyShoppingCard"
            :presalesTariff="selectedPresalesTariff"
            :tariffsExtra="tariffsExtra"
          >
            <template v-for="slot in possibleChildSlotsFor('Card')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </OrderShoppingCard>
          <div v-if="showEmptyShoppingCard" class="app-order-shopping-card-empty accordion-inner">
            <slot name="txtEmptyShoppingCard"></slot>
          </div>
        </b-collapse>
      </div>
      <!--    BestellOptionen-->
      <div class="order-options overview-process" v-if="!showSuccess">
        <div class="accordion-header">
          <slot name="txtAccordionHeaderOptions"></slot>
          <div class="accordion-btn">
            <b-btn v-if="showOptionsEditBtn" class="accordion-toggle" @click="editOptions">
              <slot name="btnEdit">Bearbeiten</slot>
            </b-btn>
          </div>
        </div>
        <b-collapse v-model="showOptions">
          <OrderOptions :top-up-amounts="topUpAmounts">
            <template v-for="slot in possibleChildSlotsFor('Options')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </OrderOptions>
        </b-collapse>
      </div>
      <!--    Persönliche Daten-->
      <div class="order-personal-data overview-process"  v-if="!showSuccess">
        <div class="accordion-header">
          <slot name="txtAccordionHeaderPersonalData"></slot>
          <div class="accordion-btn">
            <b-btn v-if="showPersonalDataEditBtn" class="accordion-toggle"
                   @click="editPersonalData">
              <slot name="btnEdit">Bearbeiten</slot>
            </b-btn>
          </div>
        </div>
        <b-collapse v-model="showPersonalData">
          <PersonalData>
            <template v-for="slot in possibleChildSlotsFor('PersonalData')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </PersonalData>
        </b-collapse>
      </div>
      <!--    Payment-->
      <div class="order-payment overview-process" v-if="!showSuccess">
        <div class="accordion-header">
          <slot name="txtAccordionHeaderPayment"></slot>
          <div class="accordion-btn">
            <b-btn v-if="showPaymentEditBtn" class="accordion-toggle" @click="editPayment">
              <slot name="btnEdit">Bearbeiten</slot>
            </b-btn>
          </div>
        </div>
        <b-collapse v-model="showPayment">
          <OrderPayment
            v-if="showPayment"
            :credit-card-frame-address="creditCardFrameAddress"
            :credit-card-redirect-url="creditCardRedirectUrl"
          >
            <template v-for="slot in possibleChildSlotsFor('OrderPayment')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </OrderPayment>
        </b-collapse>
      </div >
      <!--      Success-->
      <div class="order-success overview-process video-ident-method" v-if="showSuccess">
        <div class="accordion-header">
          <slot name="txtAccordionHeaderSuccessVideoIdentWeb" v-if="getIdentMethod === 'videoIdentWeb'">videoIdentWeb</slot>
          <slot name="txtAccordionHeaderSuccessVideoIdentPost" v-if="getIdentMethod === 'videoIdentPost'">videoIdentPost</slot>
          <slot name="txtAccordionHeaderSuccessPostIdent" v-if="getIdentMethod === 'postIdent'">postIdent</slot>
        </div>
        <b-collapse :visible="true">
            <OrderSuccess
              :slotData="getConfirmResponse"
            >
              <template v-for="slot in possibleChildSlotsFor('Success', (getIdentMethod.charAt(0).toUpperCase() + getIdentMethod.slice(1)))" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
            </OrderSuccess>
          </b-collapse>
      </div>
      <!--    Summary-->
      <div class="order-summary overview-process">
        <div class="accordion-header">
          <slot name="txtAccordionHeaderSummary" v-if="!showSuccess">Zusammenfassung</slot>
          <slot name="txtAccordionHeaderSummaryWhenSuccess" v-else>Zusammenfassung</slot>
        </div>
        <b-collapse v-model="showSummary">
          <OrderSummary
            :presalesTariff="selectedPresalesTariff"
            :tariffsExtra="tariffsExtra"
            :paypal-redirect-url="paypalRedirectUrl"
          >
            <template v-for="slot in possibleChildSlotsFor('Summary')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </OrderSummary>
        </b-collapse>
      </div>
      <slot name="txtAfter"></slot>
    </div>
  </div>
</template>

<script>
import slotProxy from '@/mixins/slotProxy'
import transaction from '@/mixins/transaction'
import extraData from '@/mixins/extraData'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import OrderShoppingCard, { stepName as shoppingCardStepName } from '@/components/process/generic/Order/otelo/ShoppingCard.vue'
import PersonalData, { stepName as personalDataStepName } from '@/components/process/generic/Order/otelo/PersonalData.vue'
import OrderPayment, { stepName as paymentStepName } from '@/components/process/generic/Order/otelo/Payment.vue'
import OrderOptions, { stepName as optionsStepName } from '@/components/process/generic/Order/otelo/Options.vue'
import OrderSummary, { stepName as summaryStepName } from '@/components/process/generic/Order/otelo/Summary/Summary.vue'
import OrderSuccess, { stepName as successStepName } from '@/components/process/generic/Order/otelo/Success.vue'
import { mapGetters, mapMutations } from 'vuex'

const processSteps = [shoppingCardStepName, optionsStepName, personalDataStepName, paymentStepName, summaryStepName, successStepName]
export default {
  name: 'OrderWrapper',
  data () {
    return {
      showAlways: true,
      presalesTariff: null,
      topUpAmounts: {
        directAmounts: {
          amount: [1000, 1500, 2000, 2500, 3000],
          default: 1000
        },
        autoAmounts: {
          monthly: {
            amount: [1000, 1500, 2000, 2500, 3000],
            default: 1000
          },
          threshold: {
            amount: [1000, 1500, 2000, 2500, 3000],
            default: 1000,
            trigger: [1000, 1500, 2000, 2500, 3000],
            defaultTrigger: 500
          }
        }
      }
    }
  },
  components: {
    OrderShoppingCard, PersonalData, OrderPayment, OrderOptions, OrderSummary, OrderSuccess
  },
  computed: {
    showEmptyShoppingCard: {
      get () {
        return this.currentStep === 'emptyShoppingCard'
      },
      set () {}
    },
    showShoppingCard: {
      get () {
        return this.currentStep === shoppingCardStepName
      },
      set () {
      }
    },
    showOptions: {
      get () {
        return this.currentStep === optionsStepName
      },
      set () {
      }
    },
    showPersonalData: {
      get () {
        return this.currentStep === personalDataStepName
      },
      set () {
      }
    },
    showPayment: {
      get () {
        return this.currentStep === paymentStepName
      },
      set () {
      }
    },
    showSummary: {
      get () {
        return this.currentStep === summaryStepName || this.showSuccess
      },
      set () {
      }
    },
    showSuccess: {
      get () {
        return this.currentStep === successStepName
      },
      set () {
      }
    },
    showOptionsEditBtn: {
      get () {
        return processSteps.indexOf(this.currentStep) > processSteps.indexOf(optionsStepName)
      },
      set () {
      }
    },
    showPersonalDataEditBtn: {
      get () {
        return processSteps.indexOf(this.currentStep) > processSteps.indexOf(personalDataStepName)
      },
      set () {
      }
    },
    showPaymentEditBtn: {
      get () {
        return processSteps.indexOf(this.currentStep) > processSteps.indexOf(paymentStepName)
      },
      set () {
      }
    },
    selectedPresalesTariff () {
      return this.presalesTariff?.bookablePresalesTariffs.find(item => item.tariffId === this.getTariffId)
    },
    tariffsExtra () {
      return this.extraData?.find(item => item.tariffId === this.getTariffId)
    },
    currentStep: function () {
      return this.getStep
    },
    ...mapGetters([
      'brand'
    ]),
    ...mapGetters('orderProduct', [
      'getStep',
      'getProcessId',
      'getConfirmResponse',
      'getCustomer',
      'getOptions',
      'getIdentMethod'
    ]),
    ...mapGetters('orderProduct/product', [
      'getTariffId',
      'getDefaultTariffId',
      'getTariffOptionId'
    ])
  },
  methods: {
    ...mapMutations('orderProduct', [
      'changeStep'
    ]),
    ...mapMutations('orderProduct/product', [
      'commitTariffId',
      'commitTariffOptionId'
    ]),
    editPersonalData () {
      this.updateStep(personalDataStepName)
    },
    editPayment () {
      this.updateStep(paymentStepName)
    },
    editOptions () {
      this.updateStep(optionsStepName)
    },
    updateStep (step) {
      this.changeStep({ step: step })
    }
  },
  mounted () {
    const urlParameters = new URLSearchParams(window.location.search)
    if (urlParameters.get('prod')) {
      const p = urlParameters.get('prod')
      if (p !== this.getTariffId) {
        this.commitTariffId(p)
        this.updateStep(shoppingCardStepName)
      } else if (p === this.getTariffId) {
        this.updateStep(this.currentStep)
      }
    }
  },
  mixins: [
    transaction('order'),
    extraData(),
    slotProxy()
  ],
  props: {
    creditCardFrameAddress: {
      type: String,
      required: true
    },
    creditCardRedirectUrl: {
      type: String
    },
    paypalRedirectUrl: {
      type: String
    }
  },
  apollo: {
    presalesTariff: function () {
      return wrapQuery(
        gql`query order ($brand: String!) {
            presalesTariff(brand: $brand) {
                bookablePresalesTariffs {
                  tariffId
                  name
                  basicFee
                  formattedBasicFee
                  connectionFee
                  contractPeriod
                  marketingGroup
                  phoneFlat
                  smsFlat
                  runtime {
                    amount
                    formattedUnit
                    unit
                  }
                  starterKit {
                    creditBalance
                    productNumber
                    shippingCost
                    singlePaymentFee
                    formattedCombinedCost
                    formattedShippingCost
                    formattedSinglePaymentFee
                    withDevice
                    withMnp
                  }
                  volumes {
                    amount
                    formattedUnit
                    unit
                  }
                }
            }
}`, this, ['presalesTariff'], { brand: this.brand }, function (data) {
        }
      )
    }
  }
}
</script>
